"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutation = exports.useLazyQuery = exports.useQuery = void 0;
const client_1 = require("@apollo/client");
const react_1 = require("react");
const libs_graphql_1 = require("@hotelplan/libs.graphql");
const libs_utils_1 = require("@hotelplan/libs.utils");
const normalizeRequestContext_1 = __importDefault(require("./normalizeRequestContext"));
const RequestContext_1 = require("./RequestContext");
function mergeOptionsAndContext(options, context) {
    var _a, _b;
    const variables = Object.assign(Object.assign({}, ((options === null || options === void 0 ? void 0 : options.variables) || {})), { context: (0, normalizeRequestContext_1.default)(Object.assign(Object.assign({}, context), (((_a = options === null || options === void 0 ? void 0 : options.variables) === null || _a === void 0 ? void 0 : _a.context) || {}))) });
    const headers = Object.assign(Object.assign({}, (((_b = options === null || options === void 0 ? void 0 : options.context) === null || _b === void 0 ? void 0 : _b.headers) || {})), { language: context === null || context === void 0 ? void 0 : context.language, device: context === null || context === void 0 ? void 0 : context.device });
    return Object.assign(Object.assign({}, options), { variables, context: Object.assign(Object.assign({}, ((options === null || options === void 0 ? void 0 : options.context) || {})), { headers }) });
}
function useQuery(document, baseOptions) {
    (0, libs_graphql_1.normalizeDocumentNode)(document);
    const context = (0, RequestContext_1.useRequestContext)();
    const queryResult = (0, client_1.useQuery)(document, mergeOptionsAndContext(baseOptions, context));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, react_1.useMemo)(() => (0, libs_utils_1.normalizeQueryData)(queryResult), [
        queryResult.data,
        queryResult.loading,
        queryResult.networkStatus,
    ]);
}
exports.useQuery = useQuery;
function useLazyQuery(query, baseOptions) {
    (0, libs_graphql_1.normalizeDocumentNode)(query);
    const context = (0, RequestContext_1.useRequestContext)();
    const [lazyQuery, res] = (0, client_1.useLazyQuery)(query, mergeOptionsAndContext(baseOptions, context));
    const lazyQueryWithContext = (0, react_1.useCallback)((options) => {
        lazyQuery(mergeOptionsAndContext(options, context));
    }, [lazyQuery, context]);
    return (0, react_1.useMemo)(() => [lazyQueryWithContext, res], [
        lazyQueryWithContext,
        res,
    ]);
}
exports.useLazyQuery = useLazyQuery;
function useMutation(mutationNode, options) {
    (0, libs_graphql_1.normalizeDocumentNode)(mutationNode);
    const context = (0, RequestContext_1.useRequestContext)();
    return (0, client_1.useMutation)(mutationNode, mergeOptionsAndContext(options, context));
}
exports.useMutation = useMutation;
//# sourceMappingURL=RequestContext.hooks.js.map